var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"field field-file"},[_c('label',{domProps:{"textContent":_vm._s(_vm.label)}}),_c('input',{ref:"file",class:{
      invalid: _vm.validation.$dirty && _vm.validation.$invalid,
    },attrs:{"type":"file"},on:{"change":_vm.input}})])}
var staticRenderFns = []

export { render, staticRenderFns }